import {Component, Inject} from '@angular/core';

import {isString, toLower, startCase} from 'lodash';
import {AcDialog, DIALOG_CONFIG, DialogConfig} from '../../ac-dialog.models';


export interface AcDialogMessageData {
    messageClass?: string;
    message?: string;
}

type AcDialogMessage =  string | string[] | AcDialogMessageData[];

export interface ConfirmDialogData {
    [key: string]: any;

    message?: AcDialogMessage;
    options?: any;
    disableModel?: boolean;
    confirmAlternativeText?: string;
}

@AcDialog({
    id: 'confirm-dialog',
    cancelButtonText: 'Close',
    multiInstanceAllowed: false,
})
@Component({
    selector: 'confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.less'],
})
export class ConfirmDialogComponent {

    messages: AcDialogMessage;
    options: any;
    disableModel = false;
    originalSubmitButtonText;
    textBoxModel = '';
    constructor(@Inject(DIALOG_CONFIG) public dialogConfig: DialogConfig) {}

    ngOnInit() {

        this.dialogConfig.submitButtonText = this.isNotEmptyString(this.dialogConfig.submitButtonText) ? startCase(toLower(this.dialogConfig.submitButtonText)) : 'OK';
        this.originalSubmitButtonText = this.dialogConfig.submitButtonText;
        this.dialogConfig.title = this.dialogConfig.title || 'Confirmation';

        const messages = this.dialogConfig.dialogData.message;
        if (!Array.isArray(messages)) {
            this.messages = [{message: this.isNotEmptyString(messages) ? messages : 'Are you sure ?'}];
        } else {
            this.messages = messages?.map((messageData) => {
                if (messageData.message) {
                    return messageData;
                }
                return {message: messageData};
            });
        }

        this.options = this.dialogConfig.dialogData.options;

        this.disableModel = this.dialogConfig.dialogData.disableModel;

        if(this.options?.checkboxModel.textBoxToConfirmText && this.options?.checkboxModel?.value === true){
            this.dialogConfig.submitButtonDisabled = true;
        }
    }

    isNotEmptyString = (value) => value && isString(value) && value !== '';

    changeSubmitButtonText = () => {
        if(this.options?.checkboxModel?.value){
            this.dialogConfig.submitButtonText = this.options?.checkboxModel?.submitButtonTextInCaseOfConfirmation;

            this.options?.checkboxModel?.textBoxToConfirmText && this.textBoxModelChanged();
        }else{
            this.dialogConfig.submitButtonText = this.originalSubmitButtonText;
            this.dialogConfig.submitButtonDisabled = false;
        }
    }

    textBoxModelChanged = () => {
        this.dialogConfig.submitButtonDisabled = !(this.options?.checkboxModel?.value === true && this.options?.checkboxModel.textBoxToConfirmText === this.textBoxModel.toLowerCase());
    }
}


